<div class="field-wrapper">
  <aura-file-input
    [control]="fileControl"
    [placeholder]="placeholder()"
    [fileAccept]="'image/*'"
    [maxFileSize]="800 * 1024"
    (fileSelected)="onAvatarSelected($event)"
  />
</div>
